import { fabric } from 'fabric';
import CanvasObject from "./CanvasObject";
import Canvas from "./../Canvas";
import apiRequestHelper from "./../../api/requestHelper";
import AppDebug from "./../../AppDebug";
import ImageObject from "./ImageObject";

class ImageGalleryObject extends ImageObject {

    static TYPE_TITLE = 'imagegallery';

    _galleryId;

    /**
     * Create a ImageObject.
     * @param {Canvas} canvas
     * @param {?string} imageContent A Base64 encoded image if it has not been uploaded yet, only added locally. If already uploaded null.
     * @param {?string} imageUrl URL if the image has already been uploaded, otherwise null by default.
     * @param {string} filename
     * @param {boolean} isResizingAllowed
     */
    constructor(canvas, imageContent, imageUrl = null, filename = '', isResizingAllowed = false) {
        super(canvas, imageContent, imageUrl, filename, isResizingAllowed);
    }

    /**
     * Object that is passed in JSON format to the API when saving the CanvasObject.
     * @returns {Object}
     */
    createObjectForSaveRequest(configurationViewId, imageId) {

        const data = super.createObjectForSaveRequest(configurationViewId, imageId);

        data.serializedObject.galleryId = this.getGalleryId();

        return data;

    }


    /**
     * Each type of object can define how its displayed in list of objects from current active product configuration view.
     * @returns {string} Filename
     */
    getCardTitleInObjectsConfigurator() {

        return {
            image: 'img/icon_type_image.png',
            title: this.getFilename()
        };

    }

    /**
     * Each type of object can define its own view in which controls are defined for the object.
     * @returns {string} Filename
     */
    getViewInObjectsConfigurator() {

        return 'ImageGalleryCanvasObject.vue';

    }

    getGalleryId() {
        return this._galleryId;
    }

    setGalleryId(value) {
        this._galleryId = value;
    }

    getIsSelectable() {
        return false;
    }

}

export default ImageGalleryObject;
